export const environment = {
  production: true,
  buildId: '2803285203519131',
  configFile: 'config.json',
};
